import React, { useCallback, useRef, useState } from "react";
import { ChildrenProps } from "../models/componentModel";
import {
    ReactFlow,
    useNodesState,
    useEdgesState,
    addEdge,
    Controls,
    Background,
    Position,
    ConnectionMode,
    MarkerType,
    type OnConnect,
    type Node,
    type Edge,
    useReactFlow,
} from '@xyflow/react';
import agent from "../services/api";
import { ACTION_TYPE_NAME, emptyCustomVariableObj, getActionTypeId, initialCustomVariableData, initialNodes, messageDataTempObject, updatedCustomVariableData } from "../components/dashboard/flowBuilder/flowBuilderConstants";
import { addChatbotCustomVariablePayload, CommonResponseModel, getCampaignContactListResponse, getChatbotCustomVariableListReasponse, intentConfigurationPayload, updateChatbotCustomVariablePayload } from "../models/axiosModel";
import { m } from "framer-motion";
import { generateUUID } from "../utils/constants";
import { debounce } from "lodash";
import { cordinates, getChatbotPostDeploymentTriggerType, getDeploymentTriggerPayload, operatorType } from "../models/flowBuilderTypes";
import { useWebhookStore } from "../store/webhookStore";
import { getExcetionActionType, mapEdgesToStepFlow, uniqueChatbotStepFlows } from "../components/dashboard/flowBuilder/utilityFunctions";
import { useFlowBuilderStore } from "../store/flowBuilderStore";
import { INSTAGRAM_ACTION_TYPES } from "../pages/ruleBasedInbox/constants";

const FlowBuilderContext = React.createContext<FlowBuilderContextPayload | undefined>(
    undefined
);

export interface selectedTriggerInterface {
    function_trigger_id: number;
    function_trigger_value: string;
    function_trigger_example_options: {
        function_trigger_example_option_id: number;
        function_trigger_example_option_value: string;
    }[];
}

export interface triggerObjectInterface {
    function_id: number;
    function_name: string;
    function_type: string;
    function_media_name: string;
    function_triggers: {
        function_trigger_id: number;
        function_trigger_value: string;
        function_trigger_example_options: {
            function_trigger_example_option_id: number;
            function_trigger_example_option_value: string
        }[] | [];
    }[];
}

export interface selectedMessageInterface {
    function_message_id: number,
    function_message_value: string
}

export interface messageObjectInterface {
    function_id: number;
    function_name: string;
    function_type: string;
    function_media_name: string;
    function_messages: {
        function_message_id: number;
        function_message_value: string;
    }[];
}

export interface FlowBuilderContextPayload {
    flagOpenFlowBuilderList: boolean | null;
    setFlagOpenFlowBuilderList: React.Dispatch<React.SetStateAction<boolean | null>>

    flagOpenLeftPanel: boolean;
    setFlagOpenLeftPanel: React.Dispatch<React.SetStateAction<boolean>>;

    flagEditWorkflowTitle: boolean;
    setFlagEditWorkflowTitle: React.Dispatch<React.SetStateAction<boolean>>;

    selectedPointerEvent: string | null;
    setSelectedPointerEvent: React.Dispatch<React.SetStateAction<string | null>>;

    triggerDataObject: triggerObjectInterface | null;
    setTriggerDataObject: React.Dispatch<React.SetStateAction<triggerObjectInterface | null>>;

    selectedTrigger: selectedTriggerInterface | null;
    setSelectedTrigger: React.Dispatch<React.SetStateAction<selectedTriggerInterface | null>>;

    selectedTriggerKeywords: string;
    setSelectedTriggerKeywords: React.Dispatch<React.SetStateAction<string>>;

    messageDataObject: messageObjectInterface | null;
    setMessageDataObject: React.Dispatch<React.SetStateAction<messageObjectInterface | null>>;

    selectedPointerMessages: selectedMessageInterface[] | null;
    setSelectedPointerMessages: React.Dispatch<React.SetStateAction<selectedMessageInterface[] | null>>;

    selectedMessageTitle: string;
    setSelectedMessageTitle: React.Dispatch<React.SetStateAction<string>>;

    operatorList: operatorType[] | null,
    setOperatorList: React.Dispatch<React.SetStateAction<operatorType[] | null>>,

    nodes: any,
    setNodes: any,
    onNodesChange: any,
    filteredNodes: any, 
    setFilteredNodes: any,
    searchQuery: string, 
    setSearchQuery: React.Dispatch<React.SetStateAction<string>>,
    currentIndex: number, 
    setCurrentIndex: React.Dispatch<React.SetStateAction<number>>,
    edges: any,
    setEdges: any
    onEdgesChange: any, 
    edgesLatestRef: React.MutableRefObject<any[]>,
    copyNode: any,
    addNode: any,
    deleteNode: any,
    generateNodesAndEdges: any,
    currentActiveNodeConfig: any,
    setCurrentActiveNodeConfig: any,

    // GetCustomVariableListApi: (chatbot_id: string) => Promise<CommonResponseModel<getChatbotCustomVariableListReasponse | null>>,
    // customVariableList: getChatbotCustomVariableListReasponse | null,
    // setCustomVariableList: React.Dispatch<React.SetStateAction<getChatbotCustomVariableListReasponse | null>>,
    // createCustomVariablePayload: addChatbotCustomVariablePayload,
    // setCreateCustomVariablePayload: React.Dispatch<React.SetStateAction<addChatbotCustomVariablePayload>>,
    // existingCustomVariablePayload: updateChatbotCustomVariablePayload,
    // setExistingCustomVariablePayload: React.Dispatch<React.SetStateAction<updateChatbotCustomVariablePayload>>,
    // flagUpdateFieldData: boolean,
    // setFlagUpdateFieldData: React.Dispatch<React.SetStateAction<boolean>>,
    // flagDataCollectionPopup: boolean,
    // flagDeleteFieldData: boolean,
    // setFlagDeleteData: React.Dispatch<React.SetStateAction<boolean>>
    onChangeCurrentActiveNodeConfig: any;
    APIQueList: any;
    setAPIQueList: any;
    updateNodeCoordinates: any;
    updateNodeStepActions: any; 
    onBlurOfFallBackOfBtnVar: any;
    updateException: any,
    tempNodesTemplate: any;
    setTempNodesTemplate: React.Dispatch<any>;
    inValidHeaderId: any;
    setInvalidHeaderId: React.Dispatch<any>;
    inValidButtonId: any;
    setInvalidButtonId: React.Dispatch<any>;
    inValidVariableId: number[],
    setInValidVariableId: React.Dispatch<React.SetStateAction<number[]>>,
    setUpdatedEdges: any;
    enqueueUpdateStepFlowActivities: (...stepFlowPayloads: any[]) => void,
    updateNodeFlow: any;
    flowDetails: any, 
    setFlowDetails: any,

    variableTypes: {
        variable_type_id: string;
        variable_type_name: string;
        variable_label: string;
    }[];
    updateFlagStartNode: any
    setVariableTypes: React.Dispatch<React.SetStateAction<{
        variable_type_id: string;
        variable_type_name: string;
        variable_label: string;
    }[]>>;
    // showVariableLable: (variable_name: string) => "Dynamic" | "Static" | undefined;
    removeFlagStartNode: any;
    deleteEdgesRelatedToStepAction: any,
    updateChatbotException: any,
    getUpdatedExceptions: any,
    getOperatorTypeApi: () => Promise<CommonResponseModel<operatorType>>,
    chatbotPostDeploymentTriggerType: getChatbotPostDeploymentTriggerType[] | null,
    setChatbotPostDeploymentTriggerType: React.Dispatch<React.SetStateAction<getChatbotPostDeploymentTriggerType[] | null>>,
    chatbotPostDeploymentTrigger: getDeploymentTriggerPayload[] | null,
    setChatbotPostDeploymentTrigger: React.Dispatch<React.SetStateAction<getDeploymentTriggerPayload[] | null>>,
    getChatbotPostDeploymentTriggerApi: (chatbotId: string) => Promise<CommonResponseModel<getDeploymentTriggerPayload>>,
    getChatbotPostDeploymentTriggerTypeApi: () => Promise<CommonResponseModel<getChatbotPostDeploymentTriggerType>>,
}



const FlowBuilderDataProvider = ({ children }: ChildrenProps) => {
    const { setViewport, zoomIn, zoomOut, fitView, setCenter } = useReactFlow();
    const handleTransform = useCallback((x: any, y: any) => {
        setViewport({ x: x, y: y, zoom: 1 }, { duration: 800 });
    }, [setViewport]);
    const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);

    const [filteredNodes, setFilteredNodes] = useState([]);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    // Sync ref so rapid sequential edge connects don't read a stale edges snapshot.
    const edgesLatestRef = useRef<any[]>([]);

    const [flagOpenFlowBuilderList, setFlagOpenFlowBuilderList] = useState<boolean | null>(null)
    const [flagOpenLeftPanel, setFlagOpenLeftPanel] = useState<boolean>(false)
    const [flagEditWorkflowTitle, setFlagEditWorkflowTitle] = useState<boolean>(false)
    const [currentActiveNodeConfig, setCurrentActiveNodeConfig] = useState({
        flagOpenConfigForm: false, nodeId: null, data: []
    })
    const [selectedPointerEvent, setSelectedPointerEvent] = useState<string | null>(null)

    const [triggerDataObject, setTriggerDataObject] = useState<triggerObjectInterface | null>(null)
    const [selectedTrigger, setSelectedTrigger] = useState<selectedTriggerInterface | null>(null)
    const [selectedTriggerKeywords, setSelectedTriggerKeywords] = useState<string>("")

    const [messageDataObject, setMessageDataObject] = useState<messageObjectInterface | null>(null)
    const [selectedPointerMessages, setSelectedPointerMessages] = useState<selectedMessageInterface[] | null>(messageDataTempObject.function_messages)
    const [selectedMessageTitle, setSelectedMessageTitle] = useState<string>("Send Message")

    const [chatbotPostDeploymentTriggerType, setChatbotPostDeploymentTriggerType] = useState<getChatbotPostDeploymentTriggerType[] | null>(null);
    const [chatbotPostDeploymentTrigger, setChatbotPostDeploymentTrigger] = useState<getDeploymentTriggerPayload[] | null>(null); 

    const getWebhookOrganizationList = useWebhookStore((state) => state.getWebhookOrganizationList);

    // const [customVariableList, setCustomVariableList] = useState<getChatbotCustomVariableListReasponse | null>(null)
    // const [createCustomVariablePayload, setCreateCustomVariablePayload] = useState<addChatbotCustomVariablePayload>(initialCustomVariableData)
    // const [existingCustomVariablePayload, setExistingCustomVariablePayload] = useState<updateChatbotCustomVariablePayload>(updatedCustomVariableData)
    // const [flagUpdateFieldData, setFlagUpdateFieldData] = useState<boolean>(false);
    // const [flagDeleteFieldData, setFlagDeleteData] = useState<boolean>(false);

    // const [flagDataCollectionPopup, setFlagDataCollectionPopup] = useState<boolean>(false);
    const [APIQueList, setAPIQueList] = useState<any>([])
    const [tempNodesTemplate, setTempNodesTemplate] = useState<any | null>(null)
    const [inValidHeaderId, setInvalidHeaderId] = useState<any>([])
    const [inValidButtonId, setInvalidButtonId] = useState<any>([])

    const [inValidVariableId, setInValidVariableId] = useState<number[]>([]); 
    const [flowDetails, setFlowDetails] = useState<any>(null);

    const [operatorList, setOperatorList] = useState<operatorType[] | null>(null);

    const [variableTypes, setVariableTypes] = useState([
        {
            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
            "variable_type_name": "Custom",
            "variable_label": "Dynamic"

        },
        {
            "variable_type_id": "3c599689-9c86-4bb9-bfd8-89b5ebc81668",
            "variable_type_name": "Static",
            "variable_label": "Static"
        },
        {
            "variable_type_id": "9cd775e9-e4db-4599-a3bd-351d9c5bca58",
            "variable_type_name": "Metadata",
            "variable_label": "Meta-Data"
        }
    ])

    // const GetCustomVariableListApi = async (chatbot_id: string): Promise<any> => {
    //     const response = await agent.getChatbotCustomVariable.get(chatbot_id);
    //     if (response.status) {
    //         setCustomVariableList(response.data)
    //     }
    //     else {
    //         setCustomVariableList(null)
    //     }
    //     return response;
    // }

    function getSourceHandleForConditionGroup(flow: any) {
        if (flow?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id) { // For, Custom Variable Condition.
            const stepFlowId = flow?.chatbot_step_flow_id;
            const chatbotCustomVriableConfigurationId = flow?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id;
            const operatorTypeId = flow?.condition_group?.custom_variable_conditions?.operator_type_id;
            return `${stepFlowId}+${chatbotCustomVriableConfigurationId}+${operatorTypeId}`;
        } else {
            return flow.condition_group.interactive_component_id;
        }
    }

    function generateNodesAndEdges(chatbotDetails: any) {
        const { chatbotActionTypeData } = useFlowBuilderStore.getState();

        const nodes: any = [];
        const edges: any = [];
        let currentVersion = chatbotDetails.currentViewVersion
        // Extract trigger node from chatbot_step_deployment_trigger_data
        let triggerUUID = generateUUID()
        let versionData = chatbotDetails?.chatbot_version_info.length > 1 ? chatbotDetails?.chatbot_version_info?.find((version: any) => version.chatbot_version_status_name.toLowerCase() == currentVersion.toLowerCase()) : chatbotDetails?.chatbot_version_info[0]
        const triggerData = versionData?.chatbot_step_deployment_trigger_data?.[0];
        if (triggerData) {
            const triggerNode = {
                id: triggerUUID,
                type: "trigger",
                data: triggerData,
                position: { x: '50', y: '50' },
                selected: false,
                dragging: false,
                chatbot_step_name: "Trigger Event",
                measured: { width: 425, height: 238 }
            };
            nodes.push(triggerNode);
        }

        // Extract chatbot steps
        const chatbotSteps = versionData?.chatbot_step_data || [];

        chatbotSteps.forEach((step: any) => {
            if (step?.chatbot_step_type?.chatbot_step_type_name?.toLowerCase() != "redeploy") { // Don't show redeploy step into the, Canvas. 
                let saveVariableAction = step.chatbot_step_action_data.filter((action: any) => action.action_type.action_type_name == ACTION_TYPE_NAME["SAVE_DATA"])
                if (saveVariableAction?.length > 0 && (saveVariableAction?.[0]?.action_data?.value_type?.toLowerCase() == "user_message_payload" || saveVariableAction?.[0]?.action_data?.value_type?.toLowerCase() == "user_flow_message_payload")) {
                    let payloadSaveVarObj = {
                        chatbot_step_action_id: saveVariableAction[0].chatbot_step_action_id,
                        action_type: {
                            "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SAVE_DATA"]),
                            "action_type_name": ACTION_TYPE_NAME["SAVE_DATA"]
                        },
                        type: 'take_value_from_payload_keys',
                        action_data: saveVariableAction
                    }
                    step.chatbot_step_action_data = step.chatbot_step_action_data.filter((action: any) => action.action_type.action_type_name !== ACTION_TYPE_NAME["SAVE_DATA"]);
                    step.chatbot_step_action_data.push(payloadSaveVarObj);
                }
                step.chatbot_step_action_data.forEach((action: any) => {
                    if (action.action_type.action_type_name == ACTION_TYPE_NAME["TEMPLATE"]) {
                        let templateUsed = chatbotDetails.additional_data.whatsapp_templates.find((template: any) => template.whatsapp_template_id == action.action_data.whatsapp_template.whatsapp_template_id)
                        if (templateUsed?.whatsapp_template_header?.whatsapp_template_header_id) {
                            templateUsed.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data = templateUsed.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.map((variable: any) => {
                                return {
                                    ...variable,
                                    action_send_dm_wa_template_variable_data: action.action_data.action_send_dm_wa_template_variable_data.find((BEVar: any) => BEVar.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)
                                }
                            })
                        }
                        if (templateUsed?.whatsapp_template_body) {
                            templateUsed.whatsapp_template_body.whatsapp_template_body_variable_data = templateUsed.whatsapp_template_body.whatsapp_template_body_variable_data.map((variable: any) => {
                                return {
                                    ...variable,
                                    action_send_dm_wa_template_variable_data: action.action_data.action_send_dm_wa_template_variable_data.find((BEVar: any) => BEVar.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)
                                }
                            })
                        }
                    }
                })
                const stepNode = {
                    id: step.chatbot_step_id,
                    type: "nodeWrapper",
                    chatbot_step_name: step.chatbot_step_name || "Send Message",
                    chatbot_step_type_id: step?.chatbot_step_type?.chatbot_step_type_id || null,
                    data: step.chatbot_step_action_data.map((action: any) => ({ ...action, flag_saved_in_BE: true })),
                    position: { x: step.coordinates.chatbot_step_x_axis, y: step.coordinates.chatbot_step_y_axis },
                    selected: false,
                    dragging: false,
                    measured: { width: 425, height: 238 }, 
                    chatbot_step_exception: step?.chatbot_step_exception ? {
                        ...step?.chatbot_step_exception, 
                        flag_saved_in_BE: true,
                        action_type: getExcetionActionType(step?.chatbot_step_exception?.flag_redeploy, step?.chatbot_step_exception?.flag_redirect, step?.chatbot_step_exception?.flag_do_nothing)
                    } : null,
                };
                nodes.push(stepNode);
            }
        });

        // This is just for, condition flow. 
        let updatedNodes = nodes;
        chatbotSteps.forEach((step: any) => {
            const stepFlow = step?.chatbot_step_flow;

            stepFlow.forEach((flow: any) => {
                if (flow?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id) {
                    updatedNodes = updatedNodes.map((node: any) => {
                        if (node.id == flow?.parent_chatbot_step_id) { // Parent Node 
                            const edgeObj = {
                                chatbot_step_action_id: generateUUID(),
                                chatbot_step_id: flow?.chatbot_step_id,
                                sequence: node.data?.length + 1,
                                "action_type": {
                                    "action_type_id": generateUUID(),
                                    "action_type_name": "Custom_Variable_Condition"
                                },
                                "action_data": {
                                    chatbot_custom_variable_configuration_id: flow?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id,
                                    operator_type_id: flow?.condition_group?.custom_variable_conditions?.operator_type_id,
                                    operator_type_name: flow?.condition_group?.custom_variable_conditions?.operator_type_name,
                                    condition_value: flow?.condition_group?.custom_variable_conditions?.condition_value,
                                    unique_id: flow?.chatbot_step_flow_id, 
                                    rhs_chatbot_custom_variable_configuration_id: flow?.condition_group?.custom_variable_conditions?.rhs_chatbot_custom_variable_configuration_id, 
                                },
                                flag_saved_in_BE: true,
                            }
                            return {
                                ...node,
                                data: [...node.data, edgeObj],
                            }
                        }
                        return node;
                    });
                }
            })
        })

        const startNode = chatbotSteps.find((step: any) => step.flag_start_node);
        if (triggerData && startNode) {
            const startEdge = {
                source: triggerUUID,
                target: startNode.chatbot_step_id,
                sourceHandle: triggerUUID,
                id: generateUUID(),
                targetHandle: startNode.chatbot_step_id,
                type: "buttonedge",
                style: {
                    strokeWidth: 2,
                    stroke: '#918d8d',
                },
                markerEnd: {
                    type: MarkerType.ArrowClosed,
                    width: 32,
                    height: 32,
                    color: '#918d8d'
                },
            };
            edges.push(startEdge);
        }
        // Create edges from chatbot_step_flow_data
        chatbotSteps.forEach((step: any) => {
            if (step.chatbot_step_flow) {
                step.chatbot_step_flow.forEach((flow: any) => {
                    if (flow.parent_chatbot_step_id && flow.chatbot_step_id) {
                        if (flow.condition_group) {
                            const buttonEdge = {
                                source: flow.parent_chatbot_step_id,
                                target: flow.chatbot_step_id,
                                sourceHandle: getSourceHandleForConditionGroup(flow),
                                id: flow.chatbot_step_flow_id,
                                // id: (flow?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id) ? `${flow?.chatbot_step_flow_id}+${flow?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id}+${flow?.condition_group?.custom_variable_conditions?.operator_type_id}` : flow.chatbot_step_flow_id,
                                targetHandle: flow.chatbot_step_id,
                                type: "buttonedge",
                                condition_type: flow.condition_group.condition_type,
                                condition_group: flow.condition_group,
                                deletable: true,
                                focusable: true,
                                style: {
                                    strokeWidth: 2,
                                    stroke: '#918d8d',
                                },
                                markerEnd: {
                                    type: MarkerType.ArrowClosed,
                                    width: 32,
                                    height: 32,
                                    color: '#918d8d'
                                },
                            };
                            edges.push(buttonEdge)
                        } else {
                            const flowEdge = {
                                source: flow.parent_chatbot_step_id,
                                target: flow.chatbot_step_id,
                                sourceHandle: flow.parent_chatbot_step_id,
                                id: flow.chatbot_step_flow_id,
                                targetHandle: flow.chatbot_step_id,
                                type: "buttonedge",
                                deletable: true,
                                focusable: true,
                                style: {
                                    strokeWidth: 2,
                                    stroke: '#918d8d',
                                },
                                markerEnd: {
                                    type: MarkerType.ArrowClosed,
                                    width: 32,
                                    height: 32,
                                    color: '#918d8d'
                                },
                            };
                            edges.push(flowEdge);
                        }
                    }
                });
            }
        });
        edgesLatestRef.current = edges
        setEdges(edges)
        setNodes(updatedNodes);

        if(chatbotSteps?.find((node: any) => node?.chatbot_step_type?.chatbot_step_type_name?.toLowerCase() == "awaitwebhook" && node?.chatbot_step_action_data?.find((action: any) => action?.action_type?.action_type_name?.toLowerCase() == "await_webhook"))){ // Get Webhook Organization Call
            getWebhookOrganizationList();
        }

        return { nodes, edges };
    }
    function getInitialActionObject(actionType: string, step_id?: string, sequence?: number, dynamicVarId?: any, cardVariationId?: number, variable_key?: string) { //this function is for when user adds a new action block inside a step
        let newSequence = sequence?.toString() || ""
        const { chatbotActionTypeData } = useFlowBuilderStore.getState();
        const defaultCustomVariableType = {
            "variable_type_id": "d1117041-48fe-4bab-a7f8-505fb48d5e42",
            "variable_type_name": "Custom"
        };
        const resolveDynamicVariableId = (value: any) => {
            if (value && typeof value === "object") {
                return value.whatsapp_template_dynamic_variable_id;
            }
            return value;
        };
        const resolveVariableType = (value: any) => {
            if (value && typeof value === "object" && value.variable_type) {
                return value.variable_type;
            }
            return defaultCustomVariableType;
        };
        switch (actionType) {
            case ACTION_TYPE_NAME["TEXT"]:
            case INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, actionType),
                        "action_type_name": actionType
                    },
                    "action_data": {
                        "action_text_message_id": generateUUID(),
                        "action_text_message_variant_data": [
                            {
                                "action_text_message_value": "",
                                "action_text_message_variant_id": generateUUID()
                            }
                        ]
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["TEMPLATE"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["TEMPLATE"]),
                        "action_type_name": ACTION_TYPE_NAME["TEMPLATE"]
                    },
                    "action_data": {
                        "action_send_dm_wa_template_id": generateUUID(),
                        "whatsapp_template": {
                            "whatsapp_template_id": null,
                            "whatsapp_template_name": null
                        },
                        "action_send_dm_wa_template_variable_data": []
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]),
                        "action_type_name": ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]
                    },
                    "action_data": {
                        "action_send_dm_wa_carousel_template_id": generateUUID(),
                        "whatsapp_template": {
                            "whatsapp_template_id": null,
                            "whatsapp_template_name": null
                        },
                        "action_send_dm_wa_carousel_template_variable_data": []
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                } 
            case ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]: 
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]),
                        "action_type_name": ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]
                    },
                    "action_data": {
                        "action_send_order_details_template_id": generateUUID(),
                        "whatsapp_template": {
                            "whatsapp_template_id": null,
                            "whatsapp_template_name": null
                        },
                        "action_send_order_details_template_variable_data": [],
                        "action_send_order_details_template_product_variable_data": [],
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["SAVE_DATA"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SAVE_DATA"]),
                        "action_type_name": ACTION_TYPE_NAME["SAVE_DATA"]
                    },
                    "action_data": {
                        "action_save_variable_id": generateUUID(),
                        "chatbot_custom_variable_configuration": {
                            "chatbot_custom_variable_configuration_id": null,
                            "chatbot_custom_variable_name": null,
                            "fallback_value": null
                        },
                        "value_type": "user_message_text",
                        "payload_key": null,
                        "flag_ai_extraction": false
                    },
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]),
                        "action_type_name": ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]
                    },
                    "action_data": {
                        "action_save_variable_id": generateUUID(),
                        "chatbot_custom_variable_configuration": emptyCustomVariableObj,
                        "variable_static_value": "",
                        "source_chatbot_custom_variable_configuration": null,
                        "value_type": "user_message_text",
                    },
                    "intents": [],
                    flag_saved_in_BE: false
                }  
            case ACTION_TYPE_NAME["RESET_DATA"]: 
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["RESET_DATA"]),
                        "action_type_name": ACTION_TYPE_NAME["RESET_DATA"]
                    },
                    "action_data": {
                        "action_reset_custom_variable_id": generateUUID(),
                        "flag_reset_all_custom_variable": false,
                        "reset_custom_variable": [],
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["ARCHIVE_CHAT"]: 
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["ARCHIVE_CHAT"]),
                        "action_type_name": ACTION_TYPE_NAME["ARCHIVE_CHAT"]
                    },
                    "action_data": {
                        "action_archive_chat_id": generateUUID(),
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["SEND_MEDIA"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SEND_MEDIA"]),
                        "action_type_name": ACTION_TYPE_NAME["SEND_MEDIA"]
                    },
                    "action_data": {
                        "action_send_dm_wa_media_id": generateUUID(),
                        "media_type": null,
                        "google_storage_id": null,
                        "caption": "",
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }

            case ACTION_TYPE_NAME["SAVE_CONTACT"]: 
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SAVE_CONTACT"]),
                        "action_type_name": ACTION_TYPE_NAME["SAVE_CONTACT"]
                    },
                    "action_data": {
                        "action_save_contact_id": generateUUID(),
                        "action_contact_list_id": null,
                        "contact_list_name": "",
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["REMOVE_CONTACT"]: 
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["REMOVE_CONTACT"]),
                        "action_type_name": ACTION_TYPE_NAME["REMOVE_CONTACT"]
                    },
                    "action_data": {
                        "action_remove_contact_id": generateUUID(),
                        "action_contact_list_id": null,
                        "contact_list_name": "",
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["RETRIEVE_CONTACT"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["RETRIEVE_CONTACT"]),
                        "action_type_name": ACTION_TYPE_NAME["RETRIEVE_CONTACT"]
                    },
                    "action_data": {
                        "action_retrieve_contact_id": generateUUID(),
                        "action_retrieve_contact_list_data": [],
                        "action_retrieve_contact_variable_data": []
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case 'add_contact_variable':
                return {
                    "action_retrieve_contact_variable_data_id": generateUUID(),
                    "contact_field_name": variable_key ?? '',
                    "chatbot_custom_variable_configuration": {
                        "chatbot_custom_variable_configuration_id": null,
                        "chatbot_custom_variable_name": null,
                        "chatbot_custom_variable_fallback_value": null
                    },
                    "fallback_value": ""
                }
            case ACTION_TYPE_NAME["ASSIGN_TAG"]:
            case ACTION_TYPE_NAME["REMOVE_TAG"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, actionType),
                        "action_type_name": actionType
                    },
                    "action_data": {
                        "action_assign_tag_id": generateUUID(),
                        "ticket_tag_id": null,
                        "ticket_tag_name": '',
                        "ticket_tag_color": null 
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["TALK_TO_AGENT"]:
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["TALK_TO_AGENT"]),
                        "action_type_name": ACTION_TYPE_NAME["TALK_TO_AGENT"]
                    },
                    "action_data": {
                        "action_talk_to_agent_id": generateUUID(),
                        "condition_group_id": "",
                        "condition_group": null,
                        "assignment_strategy_type": null,
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }

            case 'user_message_payload': 
                return {
                     "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SAVE_DATA"]),
                        "action_type_name": ACTION_TYPE_NAME["SAVE_DATA"]
                    },
                    "action_data": {
                        "action_save_variable_id": generateUUID(),
                        "chatbot_custom_variable_configuration": {
                            "chatbot_custom_variable_configuration_id": null,
                            "chatbot_custom_variable_name": null,
                            "fallback_value": null
                        },
                        "value_type": "user_message_payload",
                        "payload_key": variable_key,
                        "flag_ai_extraction": false
                    },
                    flag_saved_in_BE: false
                }
            case 'save_variable_flow_payload_message': 
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SAVE_DATA"]),
                        "action_type_name": ACTION_TYPE_NAME["SAVE_DATA"]
                    },
                    "action_data":  {
                        "action_save_variable_id": generateUUID(),
                        "chatbot_custom_variable_configuration": {
                            "chatbot_custom_variable_configuration_id": null,
                            "chatbot_custom_variable_name": null,
                            "fallback_value": null
                        },
                        "value_type": "user_flow_message_payload",
                        "payload_key": variable_key, 
                        "whatsapp_flow_id": step_id,
                        "flag_ai_extraction": false
                    },
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["CUSTOM_API"]:
                return {
                    chatbot_step_action_id: generateUUID(),
                    chatbot_step_id: step_id,
                    sequence: newSequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["CUSTOM_API"]),
                        "action_type_name": ACTION_TYPE_NAME["CUSTOM_API"]
                    },
                    "action_data": {
                        action_custom_api_call_id: generateUUID(),
                        data_connector: {
                            chatbot_data_connector_id: null
                        },
                        action_custom_api_call_request_variable_data: [],
                        action_custom_api_call_response_variable_data: []
                    }, 
                    "intents": [],
                    flag_saved_in_BE: false
                }
            case ACTION_TYPE_NAME["CONDITION"]: // This action, is just for FE & not for BE. 
                return {
                    chatbot_step_action_id: generateUUID(),
                    chatbot_step_id: step_id,
                    sequence: newSequence,
                    "action_type": {
                        "action_type_id": generateUUID(),
                        "action_type_name": ACTION_TYPE_NAME["CONDITION"]
                    },
                    "action_data": {
                        chatbot_custom_variable_configuration_id: "",
                        operator_type_id: "",
                        operator_type_name: "",
                        condition_value: "",
                    },
                    flag_saved_in_BE: false
                }
            case 'add_dynamic_variables':
                return {
                    "action_send_dm_wa_template_variable_id": generateUUID(),
                    "variable_type": resolveVariableType(dynamicVarId),
                    "chatbot_custom_variable_configuration": null,
                    "whatsapp_template_dynamic_variable_id": resolveDynamicVariableId(dynamicVarId)?.toString(),
                    "fallback_value": ""
                };
            case 'add_send_order_details_template_variables':
                return {
                    "action_send_order_details_template_variable_id": generateUUID(),
                    "variable_type": resolveVariableType(dynamicVarId),
                    "chatbot_custom_variable_configuration": null,
                    "whatsapp_template_dynamic_variable_id": resolveDynamicVariableId(dynamicVarId)?.toString(),
                    "fallback_value": ""
                }
            case 'add_send_order_details_template_product_variables':
                return {
                    "action_send_order_details_template_product_variable_id": generateUUID(),
                    "variable_type": defaultCustomVariableType,
                    "chatbot_custom_variable_configuration": null,
                    // "whatsapp_template_dynamic_variable_id": dynamicVarId?.toString(),
                    "ecom_product_id": dynamicVarId?.toString(),
                    "fallback_value": ""
                }
            case 'add_carousel_template_dynamic_variables':
                return {
                    "action_send_dm_wa_carousel_template_variable_id": generateUUID(),
                    "variable_type": resolveVariableType(dynamicVarId),
                    "chatbot_custom_variable_configuration": null,
                    "whatsapp_template_dynamic_variable_id": resolveDynamicVariableId(dynamicVarId),
                    "fallback_value": "",
                    "whatsapp_template_carousel_variation_id": cardVariationId,
                }
            case 'add_flow_variables':
                return {
                    "action_send_dm_wa_any_template_flow_input_variable_id": generateUUID(),
                    "variable_type": defaultCustomVariableType,
                    "chatbot_custom_variable_configuration": null,
                    "whatsapp_flow_variable_id": dynamicVarId,
                    "fallback_value": ""
                }
            case 'add_new_text_variant': {
                return {
                    action_text_message_value: "",
                    action_text_message_variant_id: generateUUID()
                }
            }
            case 'add_new_payload_key': {
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": sequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["SAVE_DATA"]),
                        "action_type_name": ACTION_TYPE_NAME["SAVE_DATA"]
                    },
                    "action_data": {
                        "action_save_variable_id": generateUUID(),
                        "chatbot_custom_variable_configuration": {
                            "chatbot_custom_variable_configuration_id": null,
                            "chatbot_custom_variable_name": null,
                            "chatbot_custom_variable_fallback_value": null
                        },
                        "value_type": "user_message_payload",
                        "payload_key": "",
                        "flag_ai_extraction": false
                    }
                }
            }
            case ACTION_TYPE_NAME["AWAIT_WEBHOOK"]: {
                return {
                    "chatbot_step_action_id": generateUUID(),
                    "chatbot_step_id": step_id,
                    "sequence": sequence,
                    "action_type": {
                        "action_type_id": getActionTypeId(chatbotActionTypeData, ACTION_TYPE_NAME["AWAIT_WEBHOOK"]),
                        "action_type_name": ACTION_TYPE_NAME["AWAIT_WEBHOOK"]
                    },
                    "action_data": {
                        "action_await_webhook_id": generateUUID(),
                        "expiry_timestamp": "",
                        "webhook_organization_id": "",
                        "action_await_webhook_identifier_field_data": [],
                        "action_await_webhook_save_variable": []
                    },
                }
            }
        }
    }
    function getInitialEdgeObject(edgeData: any, existingNodes: any) {
        let condition_group = null;
        let currentActionDataForCondition;
        if (edgeData?.isCustomVariable) {
            currentActionDataForCondition = existingNodes.find((node: any) => node.id == edgeData.source)?.data?.find((action: any) => action?.action_data?.unique_id == edgeData?.sourceHandle?.split('+')[0]);
        }
        if (edgeData.source !== edgeData.sourceHandle) { //this is the case for condition group
            condition_group = {
                "condition_group_id": "",
                "condition_group_name": "",
                "flag_advanced_condition": false,
                "condition_type": edgeData?.isCustomVariable ? "custom_variable" : "interactive_component",
                ...(!(edgeData?.isCustomVariable) ? {
                    "interactive_component": "template_button",
                    "interactive_component_id": edgeData.sourceHandle,
                } :
                    {
                        "custom_variable_conditions": {
                            "chatbot_custom_variable_configuration_id": currentActionDataForCondition?.action_data?.chatbot_custom_variable_configuration_id,
                            "operator_type_id": currentActionDataForCondition?.action_data?.operator_type_id,
                            "operator_type_name": currentActionDataForCondition?.action_data?.operator_type_name,
                            "condition_value": currentActionDataForCondition?.action_data?.condition_value,
                            "unique_id": currentActionDataForCondition?.action_data?.unique_id, 
                            "rhs_chatbot_custom_variable_configuration_id": currentActionDataForCondition?.action_data?.rhs_chatbot_custom_variable_configuration_id,
                        }
                    }
                )
            }
        }
        return {
            source: edgeData.source,
            target: edgeData.target,
            sourceHandle: edgeData.sourceHandle,
            id: generateUUID(),
            targetHandle: edgeData.targetHandle,
            type: "buttonedge",
            condition_type: edgeData?.isCustomVariable ? "custom_variable" : "interactive_component",
            deletable: true,
            focusable: true,
            condition_group: condition_group,
            style: {
                strokeWidth: 2,
                stroke: '#918d8d',
            },
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 32,
                height: 32,
                color: '#918d8d'
            },
        }
    }
    function getUpdatedNode(nodes: any, currentActiveNodeConfig: any, stepActionId: string, actionData: any, actionDetails: any) {
        // actionDetails = {
        //     updateType:"deleteStepAction",
        //     stepActionId:"",
        //     actionTypeOfNewActionBlock:""
        // }
        let nodeId = currentActiveNodeConfig.nodeId || ''
        let updateType = actionDetails.updateType

        let updatedNodes = nodes.map((node: any) => {
            if (node.id == nodeId) {
                let updatedData;
                switch (updateType) {
                    case "deleteStepAction":

                        updatedData = node.data.filter((action: any) => action.chatbot_step_action_id !== actionDetails.stepIdToDelete);
                        break;
                    case 'addNewStepAction':
                        updatedData = [...node.data, getInitialActionObject(actionDetails.actionTypeOfNewActionBlock ? actionDetails.actionTypeOfNewActionBlock : "", nodeId, node.data.length)];
                        break;
                    case 'editExistingStepAction':
                        updatedData = node.data.map((action: any) => {
                            if (action.chatbot_step_action_id === stepActionId) {
                                switch (action.action_type.action_type_name) {
                                    case ACTION_TYPE_NAME["TEMPLATE"]:
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action.action_data,
                                                whatsapp_template: actionData.flag_update_wa_template ? actionData.wa_template : actionData?.flag_cancel_update ? actionData.whatsapp_template : action.action_data.whatsapp_template,
                                                action_send_dm_wa_template_variable_data: actionData.flag_update_wa_template ?
                                                    actionData?.wa_variables?.length > 0 ? actionData?.wa_variables.map((dynamic: any) => getInitialActionObject('add_dynamic_variables', "", 0, dynamic)) : []
                                                    :
                                                    action.action_data.action_send_dm_wa_template_variable_data.map((variable: any) => {
                                                        if (actionData?.flag_variable_type) {
                                                            if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id)) {      //to update variable type
                                                                return {
                                                                    ...variable,
                                                                    variable_type: actionData.variable_type,
                                                                    fallback_value: "",
                                                                    chatbot_custom_variable_configuration: null
                                                                };
                                                            }
                                                            return variable;
                                                        }
                                                        else {
                                                            if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id) && actionData?.flag_fallback) {      //to update fallback or static value of variable
                                                                return {
                                                                    ...variable,
                                                                    fallback_value: actionData.fallback_value
                                                                };
                                                            }
                                                            else if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id) && !actionData?.flag_fallback) {       //to update dynamic field value of variable
                                                                if (variable.variable_type.variable_type_name == "Custom") {
                                                                    return {
                                                                        ...variable,
                                                                        chatbot_custom_variable_configuration: actionData.chatbot_custom_variable_configuration_id ? {
                                                                            chatbot_custom_variable_configuration_id: actionData.chatbot_custom_variable_configuration_id,
                                                                            chatbot_custom_variable_fallback_value: actionData.chatbot_custom_variable_fallback_value,
                                                                            chatbot_custom_variable_name: actionData.chatbot_custom_variable_name
                                                                        } : null
                                                                    };
                                                                } else {
                                                                    return {
                                                                        ...variable,
                                                                        metadata_type: { ...actionData }
                                                                    }
                                                                }
                                                            }
                                                            return variable;
                                                        }

                                                    }),
                                                action_send_dm_wa_any_template_flow_variable: actionData?.flag_update_wa_flow_variable ?  
                                                    actionData?.wa_flow_variables ?
                                                        actionData?.wa_flow_variables?.map((variable: any) => {
                                                            return {
                                                                action_send_dm_wa_template_flow_id: variable?.flow_id, 
                                                                action_send_dm_wa_any_template_flow_input_variable: variable?.flow_variables?.length > 0 ? 
                                                                    variable?.flow_variables?.map((dynamic: any) =>{
                                                                        if(dynamic?.flag_configured) {
                                                                            return dynamic?.variable_details;
                                                                        } else {
                                                                            return getInitialActionObject('add_flow_variables', "", 0, dynamic?.whatsapp_flow_variable_id);
                                                                        }
                                                                    })
                                                                    : []
                                                            }
                                                        }) : undefined
                                                    : 
                                                    action.action_data.action_send_dm_wa_any_template_flow_variable?.map((variable: any) => {
                                                        if(variable?.action_send_dm_wa_template_flow_id == actionData?.wa_flow_id){
                                                            return {
                                                                ...variable,
                                                                action_send_dm_wa_any_template_flow_input_variable: variable?.action_send_dm_wa_any_template_flow_input_variable?.map((inputVar: any) => {
                                                                    if(inputVar?.whatsapp_flow_variable_id == actionData?.whatsapp_flow_variable_id){
                                                                        if(actionData?.flag_flow_variable_type){
                                                                            return {
                                                                                ...inputVar, 
                                                                                variable_type: actionData.variable_type,
                                                                                fallback_value: "",
                                                                                chatbot_custom_variable_configuration: null
                                                                            }
                                                                        } else {
                                                                            if(actionData?.flag_fallback){
                                                                                return {
                                                                                    ...inputVar,
                                                                                    fallback_value: actionData.fallback_value
                                                                                };
                                                                            } else if(!actionData?.flag_fallback){
                                                                                if (inputVar?.variable_type.variable_type_name == "Custom") {
                                                                                    return {
                                                                                        ...inputVar,
                                                                                        chatbot_custom_variable_configuration: actionData.chatbot_custom_variable_configuration_id ? {
                                                                                            chatbot_custom_variable_configuration_id: actionData.chatbot_custom_variable_configuration_id,
                                                                                            chatbot_custom_variable_fallback_value: actionData.chatbot_custom_variable_fallback_value,
                                                                                            chatbot_custom_variable_name: actionData.chatbot_custom_variable_name
                                                                                        } : null
                                                                                    };
                                                                                } else {
                                                                                    return {
                                                                                        ...inputVar,
                                                                                        metadata_type: { ...actionData }
                                                                                    }
                                                                                }
                                                                            } 
                                                                            return inputVar;
                                                                        }
                                                                    }
                                                                    return inputVar;
                                                                }) 
                                                            }
                                                        } 
                                                        return variable;
                                                    }),
                                            }
                                        };
                                    case ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"] :
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action.action_data,
                                                whatsapp_template: actionData.flag_update_wa_template ? actionData.wa_template : actionData?.flag_cancel_update ? actionData.whatsapp_template : action.action_data.whatsapp_template,
                                                action_send_dm_wa_carousel_template_variable_data: actionData.flag_update_wa_template ?
                                                    actionData?.wa_variables?.length > 0 ? actionData?.wa_variables.map((dynamic: any) => getInitialActionObject('add_carousel_template_dynamic_variables', "", 0, dynamic, dynamic?.whatsapp_template_carousel_variation_id)) : []
                                                    :
                                                    action.action_data?.action_send_dm_wa_carousel_template_variable_data?.map((variable: any) => {
                                                        if (actionData?.flag_variable_type) {
                                                            if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id)) {      //to update variable type
                                                                return {
                                                                    ...variable,
                                                                    variable_type: actionData.variable_type,
                                                                    fallback_value: "",
                                                                    chatbot_custom_variable_configuration: null
                                                                };
                                                            }
                                                            return variable;
                                                        } else {
                                                            if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id) && actionData?.flag_fallback) {      //to update fallback or static value of variable
                                                                return {
                                                                    ...variable,
                                                                    fallback_value: actionData.fallback_value
                                                                };
                                                            }
                                                            else if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id) && !actionData?.flag_fallback) {       //to update dynamic field value of variable
                                                                if (variable.variable_type.variable_type_name == "Custom") {
                                                                    return {
                                                                        ...variable,
                                                                        chatbot_custom_variable_configuration: actionData.chatbot_custom_variable_configuration_id ? {
                                                                            chatbot_custom_variable_configuration_id: actionData.chatbot_custom_variable_configuration_id,
                                                                            chatbot_custom_variable_fallback_value: actionData.chatbot_custom_variable_fallback_value,
                                                                            chatbot_custom_variable_name: actionData.chatbot_custom_variable_name
                                                                        } : null
                                                                    };
                                                                } else {
                                                                    return {
                                                                        ...variable,
                                                                        metadata_type: { ...actionData }
                                                                    }
                                                                }
                                                            }
                                                            return variable;
                                                        }
                                                    })
                                            }
                                        };
                                    case ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]: 
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action.action_data,
                                                whatsapp_template: actionData.flag_update_wa_template ? actionData.wa_template : actionData?.flag_cancel_update ? actionData.whatsapp_template : action.action_data.whatsapp_template,

                                                action_send_order_details_template_variable_data: actionData.flag_update_wa_template ?
                                                    actionData?.wa_send_order_detail_template_variables?.length > 0 ? actionData?.wa_send_order_detail_template_variables.map((dynamic: any) => getInitialActionObject('add_send_order_details_template_variables', "", 0, dynamic)) : []
                                                    :
                                                    action.action_data?.action_send_order_details_template_variable_data.map((variable: any) => {
                                                        if(!actionData?.flag_product_variable){
                                                            if (actionData?.flag_variable_type) {
                                                                if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id)) {      //to update variable type
                                                                    return {
                                                                        ...variable,
                                                                        variable_type: actionData.variable_type,
                                                                        fallback_value: "",
                                                                        chatbot_custom_variable_configuration: null
                                                                    };
                                                                }
                                                                return variable;
                                                            }
                                                            else {
                                                                if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id) && actionData?.flag_fallback) {      //to update fallback or static value of variable
                                                                    return {
                                                                        ...variable,
                                                                        fallback_value: actionData.fallback_value
                                                                    };
                                                                }
                                                                else if (Number(variable.whatsapp_template_dynamic_variable_id) == Number(actionData.whatsapp_template_dynamic_variable_id) && !actionData?.flag_fallback) {       //to update dynamic field value of variable
                                                                    if (variable.variable_type.variable_type_name == "Custom") {
                                                                        return {
                                                                            ...variable,
                                                                            chatbot_custom_variable_configuration: actionData.chatbot_custom_variable_configuration_id ? {
                                                                                chatbot_custom_variable_configuration_id: actionData.chatbot_custom_variable_configuration_id,
                                                                                chatbot_custom_variable_fallback_value: actionData.chatbot_custom_variable_fallback_value,
                                                                                chatbot_custom_variable_name: actionData.chatbot_custom_variable_name
                                                                            } : null
                                                                        };
                                                                    } else {
                                                                        return {
                                                                            ...variable,
                                                                            metadata_type: { ...actionData }
                                                                        }
                                                                    }
                                                                }
                                                                return variable;
                                                            }
                                                        } 
                                                        return variable;

                                                    }),

                                                action_send_order_details_template_product_variable_data: actionData?.flag_update_send_order_detail_product_variable ?
                                                        actionData?.send_order_details_product_variables?.map((productVar: any) => {
                                                            if(productVar?.flag_configured){
                                                                return productVar?.variable_details;
                                                            } else {
                                                                return getInitialActionObject('add_send_order_details_template_product_variables', "", 0, productVar?.variable_details?.ecom_product_id);
                                                            }
                                                        })
                                                    :    
                                                        actionData.flag_update_wa_template ?
                                                        actionData?.wa_send_order_detail_template_product_variables?.length > 0 ? actionData?.wa_send_order_detail_template_product_variables.map((dynamic: any) => getInitialActionObject('add_send_order_details_template_product_variables', "", 0, dynamic)) : []
                                                        :
                                                        action.action_data?.action_send_order_details_template_product_variable_data.map((variable: any) => { 
                                                            if(actionData?.flag_product_variable){
                                                                if (actionData?.flag_variable_type) {
                                                                    if (variable.ecom_product_id == actionData.ecom_product_id) {      //to update variable type
                                                                        return {
                                                                            ...variable,
                                                                            variable_type: actionData.variable_type,
                                                                            fallback_value: "",
                                                                            chatbot_custom_variable_configuration: null
                                                                        };
                                                                    }
                                                                    return variable;
                                                                }
                                                                else {
                                                                    if (variable.ecom_product_id == actionData.ecom_product_id && actionData?.flag_fallback) {      //to update fallback or static value of variable
                                                                        return {
                                                                            ...variable,
                                                                            fallback_value: actionData.fallback_value
                                                                        };
                                                                    }
                                                                    else if (variable.ecom_product_id == actionData.ecom_product_id && !actionData?.flag_fallback) {       //to update dynamic field value of variable
                                                                        if (variable.variable_type.variable_type_name == "Custom") {
                                                                            return {
                                                                                ...variable,
                                                                                chatbot_custom_variable_configuration: actionData.chatbot_custom_variable_configuration_id ? {
                                                                                    chatbot_custom_variable_configuration_id: actionData.chatbot_custom_variable_configuration_id,
                                                                                    chatbot_custom_variable_fallback_value: actionData.chatbot_custom_variable_fallback_value,
                                                                                    chatbot_custom_variable_name: actionData.chatbot_custom_variable_name
                                                                                } : null
                                                                            };
                                                                        } else {
                                                                            return {
                                                                                ...variable,
                                                                                metadata_type: { ...actionData }
                                                                            }
                                                                        }
                                                                    }
                                                                    return variable;
                                                                }
                                                            } 
                                                            return variable;
                                                        }),
                                                
                                            }
                                        }
                                    case ACTION_TYPE_NAME["SAVE_DATA"]:
                                        if (actionData?.type == 'changing_payloadkey_value') { //this is for payload keys
                                            return {
                                                ...action,
                                                action_data: action?.action_data?.map((payloadKey: any) => {
                                                    return payloadKey.chatbot_step_action_id == actionData.chatbot_step_action_id ? { ...payloadKey, action_data: { ...payloadKey.action_data, payload_key: actionData.action_data.payload_key } }
                                                        :
                                                        payloadKey
                                                })
                                            };
                                        } else if (actionData?.type == 'change_payload_config') {
                                            return {
                                                ...action,
                                                action_data: action.action_data.map((payloadKey: any) => {
                                                    return payloadKey.chatbot_step_action_id == actionData.chatbot_step_action_id ? { ...payloadKey, action_data: { ...payloadKey.action_data, chatbot_custom_variable_configuration: actionData.action_data.chatbot_custom_variable_configuration, flag_ai_extraction: actionData.action_data.flag_ai_extraction } }
                                                        :
                                                        payloadKey
                                                })
                                            };
                                        } else if (actionData?.type == 'take_value_from_payload_keys') { // this is when user changes existing flow of saving variable to payload keys
                                            return {
                                                ...action,
                                                action_data: [{ ...action, action_data: { ...action?.action_data, value_type: "user_message_payload" }, value_type: "user_message_payload", payload_key: "" }], //converting the existing user_message_text to user_message_payload
                                                type: "take_value_from_payload_keys",
                                            }
                                        } else if (actionData?.type == "take_value_from_text") { //converting the existing user_message_payload to user_message_text
                                            return {
                                                ...action,
                                                action_data: {
                                                    "action_save_variable_id": action.action_data?.[0]?.action_data.action_save_variable_id || generateUUID(),
                                                    "chatbot_custom_variable_configuration": {
                                                        "chatbot_custom_variable_configuration_id": null,
                                                        "chatbot_custom_variable_name": null,
                                                        "chatbot_custom_variable_fallback_value": null
                                                    },
                                                    "value_type": "user_message_text",
                                                    "payload_key": null
                                                },
                                                type: null
                                            }
                                        } else if (actionData?.type == "add_new_payload_key") {
                                            return {
                                                ...action,
                                                action_data: [...action.action_data, getInitialActionObject("add_new_payload_key", action.chatbot_step_id, action.action_data.length)]
                                            }
                                        }
                                        else if (actionData?.type == "remove_payload_key") {
                                            return {
                                                ...action,
                                                action_data: action.action_data.filter((action: any) => action.chatbot_step_action_id !== actionData.keyToBeRemoved)
                                            }
                                        }
                                        else if (actionData?.type == 'store_backup_value') {
                                            return {
                                                ...action,
                                                backup_value: action //storing the existing action in case user hits cancels
                                            }
                                        } else if (actionData?.type == 'cancel_changes') {
                                            return action.backup_value
                                        } else if (actionData?.type == 'saving_payload_key_changes_in_BE') {
                                            return action
                                        }
                                        else if(actionData?.type == "take_value_from_payload_keys_and_flow_variables"){ 
                                            const updated_action_data = [...actionData?.already_configured_flow_variables, 
                                                ...(actionData?.flow_variables?.map((variables: any) => {
                                                    return getInitialActionObject("save_variable_flow_payload_message", actionData?.flow_id, 0, 0, 0, variables?.variable_key)
                                                }) ?? []), 
                                                ...(actionData?.payload_keys?.map((keys: any) => {
                                                    return getInitialActionObject("user_message_payload", action.chatbot_step_id,  0, 0, 0, keys);
                                                }) ?? []),
                                                ...(actionData?.wa_catalog_webhook_payload_keys?.map((keys: any) => {
                                                    return getInitialActionObject("save_variable_flow_payload_message", '', 0, 0, 0, keys?.whatsapp_webhook_payload_key_name);
                                                }) ?? []),
                                                ...(actionData?.wa_payment_webhook_payload_keys?.map((keys: any) => {
                                                    return getInitialActionObject("save_variable_flow_payload_message", '', 0, 0, 0, keys?.whatsapp_webhook_payload_key_name);
                                                }) ?? [])
                                            ]
                                            return {
                                                ...action, 
                                                action_data: updated_action_data,
                                                type: "take_value_from_payload_keys_and_flow_variables",
                                            }
                                        } 
                                        else if(actionData?.type == "update_flag_ai_extraction") {
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action.action_data,
                                                    flag_ai_extraction: actionData?.value
                                                }
                                            }
                                        } else if (actionData?.type === 'clear_selected_field') {
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action.action_data,
                                                    chatbot_custom_variable_configuration: emptyCustomVariableObj,
                                                    flag_ai_extraction: false,
                                                    action_save_variable_id: generateUUID()
                                                },
                                                chatbot_step_action_id: generateUUID()
                                            }
                                        }
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action.action_data,
                                                chatbot_custom_variable_configuration: actionData?.chatbot_custom_variable_configuration
                                                    ? actionData?.chatbot_custom_variable_configuration
                                                    : (actionData ?? emptyCustomVariableObj),
                                                ...(actionData == null && {
                                                    flag_ai_extraction: false,
                                                    action_save_variable_id: generateUUID()
                                                })
                                            },
                                            ...(actionData == null && {
                                                chatbot_step_action_id: generateUUID()
                                            })
                                        };;

                                    case ACTION_TYPE_NAME["RESET_DATA"]:
                                        if(actionData?.type == "store_backup_value"){
                                            return {
                                                ...action, 
                                                backup_value: action //storing the existing action in case user hits cancels
                                            }
                                        } else if (actionData?.type == "cancel_changes"){
                                            return action.backup_value
                                        } else if (actionData?.type == 'saving_payload_key_changes_in_BE') {
                                            return action;
                                        }
                                         else {
                                            return {
                                                ...action, 
                                                action_data: {
                                                    ...action.action_data,
                                                    flag_reset_all_custom_variable: actionData?.flag_reset_all_variable ? actionData?.flag_reset_all_custom_variable : action?.action_data?.flag_reset_all_custom_variable,
                                                    reset_custom_variable: actionData?.flag_reset_all_variable ? [] : actionData?.flag_reset_variable ? actionData?.reset_custom_variable : action?.action_data?.reset_custom_variable,
                                                }
                                            }
                                        }
                                    case ACTION_TYPE_NAME["ARCHIVE_CHAT"]: 
                                        return action;
                                    case ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]:
                                        if(actionData?.type == "store_backup_value"){
                                            return {
                                                ...action, 
                                                backup_value: action //storing the existing action in case user hits cancels
                                            }
                                        } else if (actionData?.type == "cancel_changes"){
                                            return action.backup_value
                                        } else if (actionData?.type == 'saving_payload_key_changes_in_BE') {
                                            return action;
                                        } else if(actionData?.flag_change_target_variable){
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action.action_data,
                                                    chatbot_custom_variable_configuration: actionData?.chatbot_custom_variable_configuration,
                                                }
                                            }
                                        } else if(actionData?.flag_change_source_variable){
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action.action_data,
                                                    source_chatbot_custom_variable_configuration: actionData?.chatbot_custom_variable_configuration ? actionData?.chatbot_custom_variable_configuration : emptyCustomVariableObj,
                                                }
                                            }
                                        } else if(actionData?.flag_change_static_value){
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action.action_data,
                                                    variable_static_value: actionData?.value,
                                                }
                                            }
                                        } else if(actionData?.flag_change_assign_radio_btn){
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action.action_data,
                                                    source_chatbot_custom_variable_configuration: actionData?.value ? null : emptyCustomVariableObj,
                                                    variable_static_value: actionData?.value ? "" : null,
                                                }
                                            }
                                        }
                                        else {
                                            return action;
                                        }
                                    case ACTION_TYPE_NAME["SEND_MEDIA"]: 
                                        return {
                                            ...action, 
                                            action_data: {
                                                ...action?.action_data, 
                                                media_type: actionData?.media_type,
                                                google_storage_id: actionData?.google_storage_id,
                                                caption: actionData?.caption,
                                                file_mime_type: actionData?.file_mime_type,
                                            },
                                            flag_saved_in_BE: true,
                                        }
                                    case ACTION_TYPE_NAME["SAVE_CONTACT"]:
                                    case ACTION_TYPE_NAME["REMOVE_CONTACT"]:
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action?.action_data,
                                                action_contact_list_id: actionData?.action_contact_list_id ? actionData?.action_contact_list_id : action?.action_data?.action_contact_list_id,
                                                contact_list_name: actionData?.contact_list_name ? actionData?.contact_list_name : action?.action_data?.contact_list_name,
                                            }
                                        }
                                    case ACTION_TYPE_NAME["RETRIEVE_CONTACT"]: 
                                        if(actionData?.type == "store_backup_value"){
                                            return {
                                                ...action, 
                                                backup_value: action //storing the existing action in case user hits cancels
                                            }
                                        } else if (actionData?.type == "cancel_changes"){
                                            return action.backup_value
                                        }
                                        else if(actionData?.type == 'change_contact_list') {
                                            let updatedVariableData = action?.action_data?.action_retrieve_contact_variable_data ?? [];
                                            if (actionData?.remove_all_contact_variables) {
                                                updatedVariableData = [];
                                            } else if (actionData?.contact_field_names_to_remove?.length > 0) {
                                                const fieldNamesToRemove = new Set(actionData.contact_field_names_to_remove);
                                                updatedVariableData = updatedVariableData.filter(
                                                    (variable: any) => !fieldNamesToRemove.has(variable?.contact_field_name)
                                                );
                                            }
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action?.action_data,
                                                    action_retrieve_contact_list_data: actionData?.contact_list?.map((list: getCampaignContactListResponse) => {
                                                        const isContactListExist = action?.action_data?.action_retrieve_contact_list_data?.find((cList: any) => cList?.contact_list_id === list?.contact_list_id);
                                                        if(isContactListExist) return isContactListExist;
                                                        return {
                                                            action_retrieve_contact_list_data_id: generateUUID(),
                                                            contact_list_id: list?.contact_list_id,
                                                            contact_list_name: list?.contact_list_name
                                                        }
                                                    }),
                                                    action_retrieve_contact_variable_data: updatedVariableData
                                                }
                                            }
                                        }
                                        else if(actionData?.type == 'add_contact_variable') {
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action?.action_data,
                                                    action_retrieve_contact_variable_data: [
                                                        ...action?.action_data?.action_retrieve_contact_variable_data, 
                                                        ...(actionData?.contact_fields ?? [])?.map((field: any) => getInitialActionObject("add_contact_variable", action?.chatbot_step_id,  0, 0, 0, field?.contact_field_name))
                                                    ]
                                                }
                                            }
                                        }
                                        else if(actionData?.type == 'flag_change_variable') {
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action?.action_data,
                                                    action_retrieve_contact_variable_data: action?.action_data?.action_retrieve_contact_variable_data?.map((variable: any) => {
                                                        if(variable?.action_retrieve_contact_variable_data_id === actionData?.action_retrieve_contact_variable_data_id){
                                                            return {
                                                                ...variable,
                                                                chatbot_custom_variable_configuration: {
                                                                    chatbot_custom_variable_configuration_id: actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id ?? null,
                                                                    chatbot_custom_variable_name: actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name ?? null,
                                                                    chatbot_custom_variable_fallback_value: actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_fallback_value ?? null
                                                                },
                                                                ...(!actionData?.chatbot_custom_variable_configuration && {
                                                                    fallback_value: "" 
                                                                })
                                                            }
                                                        }
                                                        return variable;
                                                    })
                                                }
                                            }
                                        }
                                        else if(actionData?.type == 'flag_change_fallback_value') {
                                            return {
                                                ...action,
                                                action_data: {
                                                    ...action?.action_data,
                                                    action_retrieve_contact_variable_data: action?.action_data?.action_retrieve_contact_variable_data?.map((variable: any) => {
                                                        if(variable?.action_retrieve_contact_variable_data_id === actionData?.action_retrieve_contact_variable_data_id){
                                                            return {
                                                                ...variable,
                                                                fallback_value: actionData?.fallback_value
                                                            }
                                                        }
                                                        return variable;
                                                    })
                                                }
                                            }
                                        }
                                        return action;
                                    case ACTION_TYPE_NAME["ASSIGN_TAG"]:
                                    case ACTION_TYPE_NAME["REMOVE_TAG"]:
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action?.action_data,
                                                ticket_tag_id: actionData?.ticket_tag_id ? actionData?.ticket_tag_id : action?.action_data?.ticket_tag_id,
                                                ticket_tag_name: actionData?.ticket_tag_name ? actionData?.ticket_tag_name : action?.action_data?.ticket_tag_name,
                                                ticket_tag_color: actionData?.ticket_tag_color ? actionData?.ticket_tag_color : null
                                            }
                                        }
                                    case ACTION_TYPE_NAME["TALK_TO_AGENT"]:
                                        return {
                                            ...action,
                                            flag_saved_in_BE: true,
                                            action_data: {
                                                ...action?.action_data,
                                                condition_group_id: actionData?.condition_group_id ?? "",
                                                condition_group: actionData?.condition_group ?? null,
                                                assignment_strategy_type: actionData?.assignment_strategy_type ?? null,
                                            }
                                        }
                                    case ACTION_TYPE_NAME["TEXT"]:
                                    case INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]:
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action.action_data,
                                                action_text_message_variant_data: actionData?.flag_variant ?
                                                    [...action.action_data.action_text_message_variant_data, getInitialActionObject('add_new_text_variant')]
                                                    :
                                                    actionData?.flag_remove_variant ?
                                                        action.action_data.action_text_message_variant_data.filter((data: any) => data.action_text_message_variant_id != actionData?.action_text_message_variant_id)
                                                        :
                                                        action.action_data.action_text_message_variant_data.map((text_variant: any) => {
                                                            return text_variant.action_text_message_variant_id == actionData.action_text_message_variant_id ? {
                                                                ...text_variant,
                                                                action_text_message_value: actionData.action_text_message_value
                                                            }
                                                                :
                                                                text_variant
                                                        })
                                            }
                                        };
                                    case ACTION_TYPE_NAME["CUSTOM_API"]:
                                        return {
                                            ...action,
                                            action_data: {
                                                ...action.action_data,
                                                data_connector: actionData.data_connector,
                                                action_custom_api_call_request_variable_data: actionData.action_custom_api_call_request_variable_data,
                                                action_custom_api_call_response_variable_data: actionData.action_custom_api_call_response_variable_data,
                                            }
                                        }
                                    case ACTION_TYPE_NAME["AWAIT_WEBHOOK"]:
                                        return {
                                            ...action,
                                            action_data: {
                                                ...actionData
                                            }
                                        }
                                    default:
                                        return action;
                                }
                            }
                            return action;

                        })
                        break;
                    case 'editActionStepOrder':
                        return node;
                }
                return {
                    ...node,
                    data: updatedData
                }
            }
            return node
        })
        return updatedNodes
    }
    function getUpdatedExceptions(currentActiveStaticWorkflow: any, flagEditingCustomErrorMessage: boolean, value: string, flagDeleteException: boolean, step_action_id?: string) {
        let payload: any;
        let currentActiveIndex = currentActiveStaticWorkflow.chatbot_version_info.findIndex((version: any) => version.chatbot_version_status_name.toLowerCase() == currentActiveStaticWorkflow.currentViewVersion.toLowerCase())

        if (currentActiveIndex === -1) {
            currentActiveIndex = 0;
        }
        let exceptionType
        if (step_action_id) {
            exceptionType = currentActiveStaticWorkflow?.chatbot_version_info[currentActiveIndex]?.chatbot_exception?.filter((exception: any) => exception.chatbot_step_action_id == step_action_id)
        } else {
            exceptionType = currentActiveStaticWorkflow?.chatbot_version_info[currentActiveIndex]?.chatbot_exception?.filter((exception: any) => !exception.chatbot_step_action_id)
        }
        if (exceptionType?.length > 0) {
            payload = { ...exceptionType[0] }
        } else {
            payload = {
                chatbot_exception_id: generateUUID(),

            }
            if (step_action_id) {
                payload = {
                    ...payload,
                    chatbot_step_action_id: step_action_id
                }
            }
        }
        if (!flagEditingCustomErrorMessage) {
            payload.exception_type = payload.exception_type || {}
            payload.exception_type.exception_type_id = value
        } else {
            payload.chatbot_exception_data = payload.chatbot_exception_data || {};
            payload.chatbot_exception_data.exception_message = value;
        }
        let updatedChatbot = {
            ...currentActiveStaticWorkflow,
            chatbot_version_info: currentActiveStaticWorkflow.chatbot_version_info.map((version: any, index: number) => {
                if (index === currentActiveIndex) {
                    const exceptions = version.chatbot_exception || [];

                    const existingIndex = exceptions.findIndex(
                        (exception: any) => exception.chatbot_exception_id === payload.chatbot_exception_id
                    );

                    let updatedExceptions;
                    if (existingIndex !== -1) {
                        // Replace the existing object
                        if (flagDeleteException) {
                            updatedExceptions = exceptions.filter((exception: number, index: number) => index !== existingIndex)
                        } else {
                            updatedExceptions = [...exceptions];
                            updatedExceptions[existingIndex] = payload;
                        }
                    } else {
                        // Add the new object
                        updatedExceptions = [...exceptions, payload];
                    }

                    return {
                        ...version,
                        chatbot_exception: updatedExceptions,
                    };
                }

                return version;
            }),
        }
        return {
            updatedVersionData: updatedChatbot,
            currentActiveIndex: currentActiveIndex
        }
    }

    function updateChatbotException(currentActiveStaticWorkflow: any, flagEditingCustomErrorMessage: boolean, value: string, flagDeleteException: boolean, actionId?: string) {
        let updatedChatbot = getUpdatedExceptions(currentActiveStaticWorkflow, flagEditingCustomErrorMessage, value, flagDeleteException, actionId)

        let payload = {
            activity_type: "update_chatbot_exception",
            chatbot_exception: updatedChatbot.updatedVersionData.chatbot_version_info[updatedChatbot.currentActiveIndex].chatbot_exception
        }
        setAPIQueList((prevState: any) => {
            return [...prevState, payload]
        })
    }
    function onChangeCurrentActiveNodeConfig(nodes: any, currentActiveNodeConfig: any, stepActionId: string, actionData: any, actionDetails: any) {
        let updatedNodes = getUpdatedNode(nodes, currentActiveNodeConfig, stepActionId, actionData, actionDetails)
        setNodes(updatedNodes)
    }
    const onBlurOfFallBackOfBtnVar = useCallback(
        debounce((nodes, currentActiveNodeConfig, stepActionId: string, actionData: any, actionDetails: any) => {
            updateNodeStepActions(nodes, currentActiveNodeConfig, stepActionId, actionData, actionDetails)
        }, 1200), []
    );
    function copyNode(id: any) {
        let node: any = nodes.find((node: any) => node.id == id)
        let nodeToBeCopied: any
        if (node) {
            nodeToBeCopied = JSON.parse(JSON.stringify(node))
        }
        nodeToBeCopied = {
            ...nodeToBeCopied,
            position: { x: (Number(node?.position.x) + 50).toString(), y: (Number(node?.position.y) + 50).toString() },
            id: generateUUID(),
            selected: false,
            dragging: false
        }
        updateNodeCoordinates(nodeToBeCopied)
        setNodes((prevState: any) => {
            return [...prevState, nodeToBeCopied]
        })
    }
    function updateNodeCoordinates(node: any) { //this function is for batch update call for update coordinates
        let payload = {
            activity_type: "update_coordinates",
            coordinates: {
                chatbot_step_x_axis: node.position.x,
                chatbot_step_y_axis: node.position.y
            },
            chatbot_step_id: node.id,
            chatbot_step_name: node.chatbot_step_name || `Step ${node.length}`,
            chatbot_step_type_id: node?.chatbot_step_type_id ?? null
        }

        setAPIQueList((prevState: any) => {
            return [...prevState, payload]
        })
    }
    function removeFlagStartNode(prevTargetNode: any) {
        let payload2 = {
            activity_type: "update_flag_start_node",
            chatbot_step_id: prevTargetNode.id,
            flag_start_node: false
        }
        setAPIQueList((prevState: any) => {
            return [...prevState, payload2]
        })
    }
    function updateFlagStartNode(node: any, prevTargetNode: any) {
        let payload = {
            activity_type: "update_flag_start_node",
            chatbot_step_id: node.id,
            flag_start_node: true
        }

        if (prevTargetNode) {
            setAPIQueList((prevState: any) => {
                let payload2 = {
                    activity_type: "update_flag_start_node",
                    chatbot_step_id: prevTargetNode.id,
                    flag_start_node: false
                }
                return [...prevState, payload, payload2]
            })
        } else {
            setAPIQueList((prevState: any) => {
                return [...prevState, payload]
            })
        }
    }
    function deleteEdgesRelatedToStepAction(existingEdges: any, nodeID: any) {
        let edgesTemp = existingEdges.filter((edge: any) => (edge.source == nodeID && (edge.source == edge.sourceHandle || edge.condition_type == "custom_variable")) || edge.source != nodeID)
        edgesLatestRef.current = edgesTemp
        setEdges(edgesTemp)

    }
    function getUpdatedEdges(actionDetails: any, existingEdges: any, existingNodes: any) {
        let updatedEdges;
        switch (actionDetails.actionType) {
            case 'addNewEdge':
                let sourceAlreadyConnected = existingEdges.find((edge: any) => edge.source == actionDetails.edgeData.source && edge.sourceHandle == actionDetails.edgeData.sourceHandle)
                if (sourceAlreadyConnected) {//if the edge already exist from this source, delete the existing and create new
                    let filteredEdges = existingEdges.filter((edge: any) => edge.id !== sourceAlreadyConnected.id)
                    updatedEdges = [...filteredEdges, getInitialEdgeObject(actionDetails.edgeData, existingNodes)];
                    return updatedEdges
                }
                return [...existingEdges, getInitialEdgeObject(actionDetails.edgeData, existingNodes)];
            case 'deleteEdge':
                updatedEdges = existingEdges.filter((edge: any) => edge.id !== actionDetails.edgeToBeDeleted);
                break;
        }

        return updatedEdges
    }
    function setUpdatedEdges(actionDetails: any, existingNodes: any, existingEdges: any, flagupdate?: boolean) {
        const baseEdges = edgesLatestRef.current;
        const updatedEdges = getUpdatedEdges(actionDetails, baseEdges, existingNodes)
        if (updatedEdges) {
            edgesLatestRef.current = updatedEdges
        }
        // Reuse the same edge objects for state + API so chatbot_step_flow_id is not regenerated.
        if (actionDetails.actionType == "addNewEdge" && flagupdate) {
            updateNodeFlow(actionDetails, existingNodes, baseEdges, updatedEdges)
        }
        setEdges(updatedEdges)
    }

    const enqueueUpdateStepFlowActivities = (...stepFlowPayloads: any[]) => {
        const stepIdsToReplace = new Set(stepFlowPayloads.map((payload) => payload?.chatbot_step_id));
        setAPIQueList((prevState: any) => {
            const withoutStale = prevState.filter((item: any) =>
                !(item.activity_type === "update_step_flow"
                    && stepIdsToReplace.has(item.chatbot_step_id)
                    && !item.flag_saved_in_BE)
            );
            return [...withoutStale, ...stepFlowPayloads];
        });
    }

    function updateNodeFlow(actionDetails: any, nodes: any, existingEdges: any, precomputedUpdatedEdges?: any) {
        let targetEdges;
        let sourceAlreadyConnected = existingEdges.find((edge: any) => edge.source == actionDetails.edgeData.source && edge.sourceHandle == actionDetails.edgeData.sourceHandle)
        let triggerNodeId = nodes.find((node: any) => node.type.toLowerCase() == "trigger").id
        if (sourceAlreadyConnected) {//if the edge already exist from this source, delete the existing
            targetEdges = existingEdges.filter((edge: any) => edge.target == sourceAlreadyConnected.target).filter((edge: any) => edge.id !== sourceAlreadyConnected.id && edge.source !== triggerNodeId)
        }
        let updatedEdges = precomputedUpdatedEdges ?? getUpdatedEdges(actionDetails, existingEdges, nodes);
        let childNodeEdges = updatedEdges.filter((edge: any) => edge.target == actionDetails.edgeData.target && edge.source !== triggerNodeId);
        let payload = {
            chatbot_step_id: actionDetails.edgeData.target,
            activity_type: "update_step_flow",
            chatbot_step_flow: mapEdgesToStepFlow(childNodeEdges)
        }

        // When condition edge is delete, generate new UUID for new connection.
        if(actionDetails?.actionType == "deleteEdge" && actionDetails?.edgeData?.condition_type === 'custom_variable') {
            setNodes((prev) => {
                return prev?.map((node: any) => {
                    if(node?.id === actionDetails?.edgeData?.source){
                        return {
                            ...node,
                            data: node?.data?.map((action: any) => {
                                if(action?.action_type?.action_type_name === ACTION_TYPE_NAME['CONDITION'] && action?.action_data?.unique_id === actionDetails?.edgeData?.id){
                                    return {
                                        ...action,
                                        action_data: {
                                            ...action?.action_data,
                                            unique_id: generateUUID(),
                                        }
                                    }
                                }
                                return action;
                            })
                        }
                    }
                    return node;
                })
            });
        }

        if (sourceAlreadyConnected && actionDetails.actionType !== "deleteEdge") {


            if(sourceAlreadyConnected.target === actionDetails.edgeData.target){
                payload = {
                    ...payload,
                    chatbot_step_flow: uniqueChatbotStepFlows([
                        ...payload?.chatbot_step_flow,
                        ...mapEdgesToStepFlow(targetEdges ?? [])
                    ])
                }
                enqueueUpdateStepFlowActivities(payload);
            } else {
                let targetEdgePayload = {
                    chatbot_step_id: sourceAlreadyConnected.target,
                    activity_type: "update_step_flow",
                    chatbot_step_flow: mapEdgesToStepFlow(targetEdges)
                }
                enqueueUpdateStepFlowActivities(payload, targetEdgePayload);
            }
        } else {
            enqueueUpdateStepFlowActivities(payload);
        }
    }
    function filterStepActionsThatCanBeUpdated(actionObject: any) {  //this function is for batch update call for update coordinates
        let actionTypeName = actionObject.action_type.action_type_name

        let actionObj = {
            ...actionObject,
            intent: actionObject?.intents?.map((intentData: intentConfigurationPayload) => {
                return {
                    intent_id: intentData?.intent_id, 
                    chatbot_custom_variable_configuration_id: intentData?.chatbot_custom_variable_configuration_id,
                    condition_group: intentData?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id ? intentData?.condition_group : null,
                    flag_duplicate: intentData?.flag_duplicate,
                }
            })
        }
        switch (actionTypeName) {
            case ACTION_TYPE_NAME["TEXT"]:
            case INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]:
                // if (actionObj.action_data && actionObj.action_data.action_text_message_variant_data) {
                //     if (actionObj.action_data.action_text_message_variant_data.every((action: any) => action.action_text_message_value == "")) { //if every variant value is empty
                //         return null
                //     } else { //filtering the variants which have value
                //         actionObj.action_data.action_text_message_variant_data = actionObj.action_data.action_text_message_variant_data.filter((action: any) => action.action_text_message_value !== "")
                //         return actionObj
                //     }
                // }
                // return null
                return actionObj
            case ACTION_TYPE_NAME["TEMPLATE"]:
            case ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]:
                if (actionObj.action_data && actionObj.action_data.whatsapp_template) {
                    if (actionObj.action_data && !actionObj.action_data.whatsapp_template.whatsapp_template_id) { //if template is not setup
                        return null
                    } else { 
                        if(actionObj?.action_data?.action_send_dm_wa_any_template_flow_variable && actionObj?.action_data?.action_send_dm_wa_any_template_flow_variable?.length > 0){
                            return {
                                ...actionObj, 
                                action_data: {
                                    ...actionObj?.action_data,
                                    action_send_dm_wa_any_template_flow_variable: actionObj?.action_data?.action_send_dm_wa_any_template_flow_variable?.map((flowVariable: any) => {
                                        return {
                                            ...flowVariable, 
                                            action_send_dm_wa_any_template_flow_input_variable: flowVariable?.action_send_dm_wa_any_template_flow_input_variable?.filter((inputVar: any) => {
                                                return (inputVar?.chatbot_custom_variable_configuration || inputVar?.metadata_type?.metadata_type_id || inputVar?.fallback_value?.trim()?.length > 0)
                                            })
                                        }
                                    }) 
                                }
                            }
                        }
                        return actionObj
                    }
                }
                return null
            // return actionObj

            case ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]: 
                if (actionObj.action_data && actionObj.action_data.whatsapp_template) {
                     if (actionObj.action_data && !actionObj.action_data.whatsapp_template.whatsapp_template_id) { //if template is not setup
                        return null
                    } else {
                        if(actionObj?.action_data?.action_send_order_details_template_product_variable_data && actionObj?.action_data?.action_send_order_details_template_product_variable_data?.length > 0){
                            return {
                                ...actionObj, 
                                action_data: {
                                    ...actionObj.action_data, 
                                    action_send_order_details_template_product_variable_data: actionObj?.action_data?.action_send_order_details_template_product_variable_data?.filter((variable: any) => {
                                        return variable?.chatbot_custom_variable_configuration || variable?.metadata_type?.metadata_type_id || variable?.fallback_value?.trim()?.length > 0
                                    })
                                }
                            }
                        }
                    }
                }
                return null;

            case ACTION_TYPE_NAME["SAVE_DATA"]:
                if (actionObj.type) {
                    return actionObj.action_data?.filter((action: any) => action?.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id)
                }
                if (!actionObj.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) {
                    return null;
                }
                return actionObj;
            case ACTION_TYPE_NAME["RETRIEVE_CONTACT"]:
                return {
                    ...actionObj,
                     action_data: {
                        ...actionObj.action_data, 
                        action_retrieve_contact_variable_data: actionObj?.action_data?.action_retrieve_contact_variable_data?.filter((variable: any) => {
                            return variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id
                        })
                    }
                }
            case ACTION_TYPE_NAME["RESET_DATA"]:
            case ACTION_TYPE_NAME["ARCHIVE_CHAT"]:
            case ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]:
            case ACTION_TYPE_NAME["SEND_MEDIA"]:
            case ACTION_TYPE_NAME["SAVE_CONTACT"]:
            case ACTION_TYPE_NAME["REMOVE_CONTACT"]:
            case ACTION_TYPE_NAME["ASSIGN_TAG"]:
            case ACTION_TYPE_NAME["REMOVE_TAG"]:
            case ACTION_TYPE_NAME["TALK_TO_AGENT"]:
            case ACTION_TYPE_NAME["CUSTOM_API"]:
            case ACTION_TYPE_NAME["AWAIT_WEBHOOK"]:
                return actionObj;

        }
    }
    function updateNodeStepActions(nodes: any, currentActiveNodeConfig: any, stepActionId: string, actionData: any, actionDetails: any) {
        let updatedNodes = getUpdatedNode(nodes, currentActiveNodeConfig, stepActionId, actionData, actionDetails)
        let node: any = updatedNodes?.find((node: any) => node.id == currentActiveNodeConfig.nodeId)
        let payload = {
            activity_type: "update_step",
            chatbot_step_id: node?.id,
            chatbot_step_action: node?.data.map((action: any) => filterStepActionsThatCanBeUpdated(action)).filter((action: any) => action != null).flat(),
            chatbot_step_type_id: node?.chatbot_step_type_id
        }
        setAPIQueList((prevState: any) => {
            return [...prevState, payload]
        })
    } 

    function updateException(nodes: any, step_id: string, step_type_id: string, flag_delete: boolean){ 
        // const stepException = currentActiveStaticWorkflow?.chatbot_version_info?.find((version: any) => version?.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_data?.find((step: any) => step?.chatbot_step_id == step_id)?.chatbot_step_exception 
        const stepException = nodes?.find((node: any) => (node?.id == step_id))?.chatbot_step_exception;
        let payload = {
            activity_type: "update_exception",
            chatbot_step_id: step_id,
            chatbot_step_type_id: step_type_id,
            chatbot_exception: {
                chatbot_step_exception_id: stepException?.chatbot_step_exception_id,
                target_chatbot_step_id: stepException?.target_chatbot_step?.target_chatbot_step_id, 
                exception_message: stepException?.exception_message, 
                flag_delete: flag_delete,
            }
        } 

        setAPIQueList((prevState: any) => {
            return [...prevState, payload];
        })
    }

    function addNode(node: any, nodes: any, flagInheritNodePosition: boolean, position?: cordinates) {
        let newNode = {
            ...node,
            id: flagInheritNodePosition ? node.id : generateUUID(),
            // position: flagInheritNodePosition ? node.position : { x: (Number(nodes[nodes.length - 1].position.x) + 50).toString(), y: (Number(nodes[nodes.length - 1].position.y) + 50).toString() },
            position: flagInheritNodePosition ? node.position : position,
            chatbot_step_name: `Step ${nodes.length}`,
        }
        updateNodeCoordinates(newNode)
        setNodes((prevState: any) => {
            return [...prevState, newNode]
        })
        // setTimeout(() => {
        // fitView({
        //     nodes: [{ id: newNode.id }],
        //     duration: 800,
        //     minZoom: 0.7,
        //     maxZoom: 0.7
        // })

        // const x = node.position.x + node.width / 2;
        // const y = node.position.y + node.height / 2;
        // setCenter(x, y, {
        //     duration: 800,
        // });
        // }, 500)
        // handleTransform((Number(nodes[nodes.length - 1].position.x) + 50), (Number(nodes[nodes.length - 1].position.y) + 50))
    }
    function deleteNode(id: string) {
        let source = nodes.find((node: any) => node.id == id)?.id
        if (source) {
            let newEdges = edges.filter((edge: any) => edge.source !== source && edge.target !== source)
            edgesLatestRef.current = newEdges
            setEdges(newEdges)
        }
        if (id == currentActiveNodeConfig.nodeId) {
            setCurrentActiveNodeConfig({ flagOpenConfigForm: false, nodeId: null, data: [] })
        }

        let payload = {
            activity_type: "delete_step",
            chatbot_step_id: id
        }

        setAPIQueList((prevState: any) => {
            return [...prevState, payload]
        })
        setNodes((prevState: any) => {
            return prevState.filter((node: any) => node.id !== id)
        });
    }
    function editNodeConfigurationData(nodeId: any, chatbot_step_action_id: string) {
        setNodes((prevState: any) => {
            return prevState.map((node: any) => {
                if (node.id == nodeId) {
                    return {
                        ...nodeId, data: node.data.map((action: any) => {
                            if (action.chatbot_step_action_id == chatbot_step_action_id) {
                                // set
                            }
                            return action
                        })
                    }
                }

                return node
            })
        })
    }
    // const showVariableLable = (variable_name: string) => {
    //     switch (variable_name) {
    //         case 'Custom':
    //             return "Dynamic"
    //         case 'Static':
    //             return "Static"
    //     }
    // }

    const getOperatorTypeApi = async () => {
        const res = await agent.getOperatorType.get();
        if (res.status) {
            setOperatorList(res.data);
        } else {
            setOperatorList(null);
        }
        return res;
    }

    const getChatbotPostDeploymentTriggerApi = async (chatbotId: string) => {
        const res = await agent.getChatbotPostDeploymentTrigger.get(chatbotId);
        if (res.status) {
            setChatbotPostDeploymentTrigger(res.data?.map((data: any) => {
                return {
                    ...data,
                    action_type: data?.chatbot_step?.chatbot_step_type?.chatbot_step_type_name?.toLowerCase() == "redeploy" ? "ReDeploy" : "ReDirect",
                }
            })?.filter((data: any) => data?.chatbot_post_deployment_trigger_type?.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "keyword"));
        } else {
            setChatbotPostDeploymentTrigger(null);
        }
        return res;
    }

    const getChatbotPostDeploymentTriggerTypeApi = async () => {
        const res = await agent.getChatbotPostDeploymentTriggerType.get();
        if (res.status) {
            setChatbotPostDeploymentTriggerType(res.data);
        } else {
            setChatbotPostDeploymentTriggerType(null);
        }
        return res;
    }

    const payload = {
        flagOpenFlowBuilderList,
        setFlagOpenFlowBuilderList,
        flagEditWorkflowTitle,
        setFlagEditWorkflowTitle,
        triggerDataObject,
        setTriggerDataObject,
        selectedPointerEvent,
        setSelectedPointerEvent,
        flagOpenLeftPanel,
        setFlagOpenLeftPanel,
        selectedTrigger,
        setSelectedTrigger,
        selectedTriggerKeywords,
        setSelectedTriggerKeywords,
        messageDataObject,
        setMessageDataObject,
        selectedPointerMessages,
        setSelectedPointerMessages,
        selectedMessageTitle,
        setSelectedMessageTitle,
        nodes,
        setNodes,
        onNodesChange,
        filteredNodes, 
        setFilteredNodes,
        searchQuery, 
        setSearchQuery,
        currentIndex, 
        setCurrentIndex,
        edges,
        setEdges,
        onEdgesChange,
        edgesLatestRef,
        copyNode,
        addNode,
        deleteNode,
        generateNodesAndEdges,
        currentActiveNodeConfig,
        setCurrentActiveNodeConfig,
        // GetCustomVariableListApi,
        // customVariableList,
        // setCustomVariableList,
        // createCustomVariablePayload,
        // setCreateCustomVariablePayload,
        // existingCustomVariablePayload,
        // setExistingCustomVariablePayload,
        // flagUpdateFieldData,
        // setFlagUpdateFieldData,
        // flagDataCollectionPopup,
        // setFlagDataCollectionPopup,
        // flagDeleteFieldData,
        // setFlagDeleteData,
        onChangeCurrentActiveNodeConfig,
        APIQueList,
        setAPIQueList,
        updateNodeCoordinates,
        updateNodeStepActions,
        onBlurOfFallBackOfBtnVar,
        updateException,
        tempNodesTemplate,
        setTempNodesTemplate,
        inValidHeaderId,
        setInvalidHeaderId,
        inValidButtonId,
        setInvalidButtonId,
        inValidVariableId,
        setInValidVariableId,
        setUpdatedEdges,
        enqueueUpdateStepFlowActivities,
        updateNodeFlow,
        variableTypes,
        setVariableTypes,
        // showVariableLable,
        updateFlagStartNode,
        removeFlagStartNode,
        deleteEdgesRelatedToStepAction,
        updateChatbotException,
        getUpdatedExceptions,
        operatorList,
        setOperatorList,
        getOperatorTypeApi,
        chatbotPostDeploymentTriggerType,
        setChatbotPostDeploymentTriggerType,
        chatbotPostDeploymentTrigger,
        setChatbotPostDeploymentTrigger,
        getChatbotPostDeploymentTriggerApi,
        getChatbotPostDeploymentTriggerTypeApi, 
        flowDetails, 
        setFlowDetails,
    };
    return <FlowBuilderContext.Provider value={payload}>{children}</FlowBuilderContext.Provider>;
};

export { FlowBuilderContext, FlowBuilderDataProvider };
